export default __webpack_public_path__ + "static/media/starSelected.10a17c96.svg";